import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput,
    SelectInput,
    required
} from 'react-admin';
import { useForm } from 'react-final-form';
import Choices from './Namechoices'

const getType=(value) => {
    
    if(value != '' && value !== null){
        return value && typeof(value) ==='string'? value.split(',')[1] : value;
    }else {
         //console.log(value)
        return null
    }
}

let choiceSet = []

const setChoices=(data)=>{
    choiceSet = data;
}

const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();
    //console.log(formData)
    return (
        <Fragment>
            <Choices setChoices={setChoices}   />
            <SelectInput
                source="name"
                label="Training Name"
                choices={choiceSet}
                onChange={value => form.change('freq_type', null )}
                validate={required()}
                {...rest}
            />
            <br/>
            <TextInput
                style={{display: 'none'}}
                source="freq_type"
                label=""
                value = {
                    getType(formData.name),
                    formData.freq_type = getType(formData.name)
                }
                {...rest}
            />
        </Fragment>
    );
};


const SelectTraining = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default SelectTraining